/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PaymentEventProperties } from "./PaymentEventProperties";
import type { UserProgressionStateModel } from "./UserProgressionStateModel";

/**
 * The updated progression and conversion payload for the FE's paired ad event
 */
export interface CheckoutSuccessResponse {
  progression: UserProgressionStateModel;
  payment_properties: PaymentEventProperties | null;
}
